export const RECOMMENDATIONS_LIST = "/recommendations";
export const ARCHIVED_RECOMMENDATIONS = "/recommendations/archived";
export const ADD_RECOMMENDATION = "/recommendations/add";
export const EDIT_RECOMMENDATION = "/recommendations/edit/:id";
